export default function draw() {
  this.ctx.beginPath();
  this.ctx.fillStyle = this.coef.background;
  this.anim.radius += 0.3;
  this.ctx.arc(this.anim.x, this.anim.y, this.anim.radius * 2, 0, Math.PI * 2);
  this.ctx.fill();
  this.ctx.font = `${this.font.font}px regularGT`;
  this.font.font += 0.3;
  this.ctx.fillStyle = "#353752";

  this.ctx.textAlign = "center";
  this.ctx.textBaseline = "middle";

  this.ctx.fillText(this.coef.coef, this.font.x, this.font.y);
}

// this.anim.radius += 1;
// this.ctx.font = `${this.r * 2}px blah`;
// this.ctx.fillStyle = "#6168af";
// this.cts.scale(2, 2);
// this.font.size += 1 / 2;
// this.font.x -= 1 / 4;
// this.font.y += 1 / 4;
